import { createContext, useContext, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const Ctx = createContext({ rate: null, date: null, source: null, loading: true, error: false });

export const useExchangeRate = () => useContext(Ctx);

export const toMxn = (usdAmount, rate) => (rate ? usdAmount * rate : null);

export const ExchangeRateProvider = ({ children }) => {
  const [state, setState] = useState({ rate: null, date: null, source: null, loading: true, error: false });

  useEffect(() => {
    fetch(`${API}/api/exchange-rate`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => setState({ ...d, loading: false, error: false }))
      .catch(() => setState((s) => ({ ...s, loading: false, error: true })));
  }, []);

  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
};

export default ExchangeRateProvider;
